import { render, staticRenderFns } from "./BasketNavItem.vue?vue&type=template&id=74128307&scoped=true"
import script from "./BasketNavItem.vue?vue&type=script&lang=js"
export * from "./BasketNavItem.vue?vue&type=script&lang=js"
import style0 from "./BasketNavItem.vue?vue&type=style&index=0&id=74128307&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74128307",
  null
  
)

export default component.exports